import clsx from 'clsx';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { faQuestionCircle } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon } from '@seeqdev/qomponents';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface LabelIF extends ValidatingFormComponent<string | React.ReactNode> {
  component: 'LabelFormComponent';
  noMarginBottom?: boolean;
  onIconClick?: () => any;
  valueCustomParams?: Record<string, string | number>;
  onClick?: () => void;
  skipTranslation?: boolean;
  textClassNames?: string;
}

const LabelFormComponentUnwrapped = ({
  value,
  tooltip,
  onIconClick,
  onClick,
  testId,
  extraClassNames,
  noMarginBottom,
  tooltipDelay,
  tooltipPlacement,
  valueCustomParams,
  skipTranslation = false,
  textClassNames,
}: LabelIF) => {
  const { t } = useTranslation();

  const textContent = _.isString(value) && !skipTranslation ? t(value, valueCustomParams) : value;

  return (
    <div
      className={clsx('flexColumnContainer', extraClassNames, {
        mb5: !noMarginBottom,
      })}
      onClick={onClick}
      data-testid={testId}>
      <span className={textClassNames}>{textContent}</span>
      {tooltip && (
        <Icon
          icon={faQuestionCircle}
          large={true}
          tooltip={t(tooltip)}
          tooltipDelay={tooltipDelay}
          tooltipPlacement={tooltipPlacement}
          extraClassNames="tw:pl-sq-5"
          testId={`${testId}_icon`}
          onClick={_.isFunction(onIconClick) ? onIconClick : _.noop}
        />
      )}
    </div>
  );
};

export const LabelFormComponent = React.memo(
  LabelFormComponentUnwrapped,
  (prev, next) =>
    !(
      prev.value !== next.value ||
      prev.tooltip !== next.tooltip ||
      prev.extraClassNames !== next.extraClassNames ||
      prev.textClassNames !== next.textClassNames
    ),
);
